module.exports = __webpack_public_path__ + "img/poplar-mask.5eb5ca3d.png";